import { render, staticRenderFns } from "./Komchat.vue?vue&type=template&id=37c4b73d&"
import script from "./Komchat.vue?vue&type=script&lang=js&"
export * from "./Komchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports